<template>
  <div>
    <div class="printBtnBox">
      <el-button class="printBtn" type="primary" @click="printHandle">打印</el-button>
    </div>
    <div id="print" class="printContent" :contentLoading="contentLoading">
      <div v-for="item in outStockBillVOS" :key="item.pkid" class="printItem">
        <table cellpadding="0" cellspacing="0">
          <tr>
            <td rowspan="4" colspan="2" style="width: 130px">
              <svg :id="'qrCode'+item.billNo"/>
            </td>
            <td colspan="4" style="font-weight: 700; font-size: 12pt" align="center">出库单</td>
          </tr>
          <tr>
            <td colspan="2" width="200px">出库单号：<span class="font-number">{{item.billNo}}</span></td>
            <td colspan="2">关联单号：<span class="font-number">{{item.relBillNo}}</span></td>
          </tr>
          <tr>
            <td colspan="2">出库类型：{{item.outStockTypeName}}</td>
            <td colspan="2">
              <template v-if="item.outStockType === 4">
                供应商名称：{{item.outStockBillDetailVOS[0].supplierName || ''}}
              </template>
              <template v-else>
                出库时间：{{item.requireDate}}
              </template>
            </td>
          </tr>
          <tr>
            <td colspan="2">物料号：<span class="font-number">{{item.parentMaterialNo}}</span></td>
            <td colspan="2">物料描述：<span class="font-number">{{item.parentMaterialName}}</span></td>
          </tr>
          <tr>
            <td colspan="3">规格型号：<span class="font-number">{{item.specification}}</span></td>
            <td colspan="3">生产备注：{{item.productionOrderNote}}</td>
          </tr>
        </table>
        <table>
          <thead>
            <tr>
              <td v-if="item.outStockType === 4" align="center">序号</td>
              <td align="center">物料编号</td>
              <td width="150px">物料名称</td>
              <td width="100px">老物料</td>
              <td align="center">仓库</td>
              <td align="center">仓位名称</td>
              <td align="center">库存</td>
              <td width="65px" align="center">需求数量</td>
              <td width="65px" align="center">实发数量</td>
              <td v-if="item.outStockType !== 4" align="center">供应商</td>
            </tr>
          </thead>
          <tr v-for="(i, index) in item.outStockBillDetailVOS" :key="i.pkid">
            <td v-if="item.outStockType === 4" align="center" class="font-number">{{index + 1}}</td>
            <td align="center" class="font-number">{{i.materialNo}}</td>
            <td class="font-number">{{i.materialName}}</td>
            <td class="font-number">{{i.mappingMaterialNo}}</td>
            <td align="center">{{constant.locationNo[i.locationNo]}}</td>
            <td class="font-number">{{i.warehouseNo}}</td>
            <td align="center" class="font-number">{{i.instockQty}}</td>
            <td align="center" class="font-number">{{i.quantity}}</td>
            <td align="center" class="font-number">{{item.outStockType !== 4 ? i.actualQuantity : ""}}</td>
            <td v-if="item.outStockType !== 4" align="center">{{i.supplierNo}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import constant from "@/util/constant";
  import barCode from "jsbarcode";
  export default {
    data() {
      return {
        constant,
        outStockBillVOS: [],
        ids: [],
        contentLoading: false,
        outStockType: "",
      };
    },

    created() {
      this.getData(this.$route.query.params, this.$route.query.outStockType);
    },

    methods: {
      getData(ids, outStockType) {  
        this.ids = ids;
        this.outStockType = Number(outStockType);
        this.contentLoading = true;
        this.$http.get("basic", `outStockBills/getAllListByIds/${ids}`).then((resp) => {
          this.outStockBillVOS = resp.data;
          for (let item of this.outStockBillVOS) {
            this.$nextTick(() => {
              document.getElementById("qrCode" + item.billNo).innerHTML = "";
              this.bindQRCode(item.billNo);
            });
          }
          this.contentLoading = false;
        });
      },

      bindQRCode(code) {
        // new barCode("#barcode" + row.billNo, row.billNo, {
        //   displayValue: false, // 是否在条形码下方显示文字
        //   format: "CODE128",
        //   height: 30,
        // });
        new barCode(
          "#qrCode" + code, code,
          {
            displayValue: true, // 是否在条形码下方显示文字
            format: "CODE128",
            height: 40,
          },
        );
      },

      printHandle() {
        document.body.innerHTML = document.getElementById("print").parentNode.innerHTML;
        window.print();
        window.location.reload();
      },
    },
  };
</script>

<style lang="scss" scoped>
.printBtnBox {
  width: 195mm; margin: 0 auto; padding: 2mm 0; position: fixed; top: 0; left: -10cm; margin-left: 50%;background-color: #fff;z-index: 999;
}
.printItem {
  width: 195mm;
  font-size: 11pt;
  margin: 10px auto;
  color: #000;
  font-weight: 500;
  font-family: 'SimSun', '宋体';
  line-height: 1.1;
  .font-number{
    font-family: 'Courier New', monospace;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #000;
    tr {
      td {
        border-bottom: 1px solid #000;
        border-right: 1px solid #000;
        padding: 2px 1px;
        word-break: break-all;
        &:last-child {
          border-right: none;
        }
      }
    }
  }
}
.printContent {
  padding-top: 50px;
}
@media print {
  .printItem {
    margin: 0;
    page-break-inside: avoid; // 避免在打印项内部分页
  }
  // 只在打印项之间添加分页符，而不是在最后一个打印项之后
  .printItem:not(:last-child) {
    page-break-after: always;
  }
  .printBtnBox{
    display: none;
  }
  .printContent {
    padding-top: 0;
  }
}
</style>
